import React, { Component } from 'react';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import OrderDetailsSummary from '../responsive/OrderDetailsSummary';
import Layout from '../../../components/desktop/Layout';
import CartProductCard from '../../../cart/components/responsive/CartProductCard';
import OrderSummary from '../../../cart/components/responsive/OrderSummary';
import FeedbackRating from '../responsive/FeedbackRating';
import Modal from '../../../components/common/Modal';
import { showModal, hideModal } from '../../../actions/modal';
import { getQuestions } from '../../../jioprime/actions/enroll-link-jpp-action';
import isNode from '../../../modules/ajio-util/isNode';
import FormattedDate from '../../../myaccount/components/responsive/FormattedDate';
import { promptUserForEmployeeId } from '../../../userauth/actions/signinAction';
import { showErrorMessageInfo } from '../../../actions/shared/HTTPError';
import ErrorMessage from '../../../components/common/ErrorMessage';

import { getAffisePixels } from '../../../utils/affise';
import AddressBox from '../../../myaccount/components/responsive/AddressBox';
import { getProductAttributionToken, isOrderPickup, getCopilotSkuCheck } from '../../../utils/common';
import properties from '../../../modules/ajio-util/properties';
import {
  gtmPurchaseComplete,
  luxeGtmPurchaseComplete,
  gtmPagePush,
  gtmEventPush,
  getStoreName,
  segmentEventPush
} from '../../../modules/ga/GTMdatalayer';
import { getLuxeFlags, getAssuredGifts } from '../../../Flags/selectors';
import {
  getAssuredGiftsFlag,
  getAssuredFlags,
  getAffiseAfSecure,
  getGiftWithProductEnable,
  getPriorityDeliveryPreOrderFlag,
  getPriorityDeliveryPhase2Flag,
  getRushDeliveryFlag,
  getPriorityDeliverySLPTagsConfig,
  getEnableAjioMemberShipProgram,
  getAjioMemberShipConfig,
  getAjioSuperCashTYPEnable,
  getAjioSuperCashCurrencyConfig,
  getAjioSuperCashEnable,
  getGSTFlag,
  getGstEnhancementFlag,
  getAffiliateFeatureConfig,
  getEnableNonReturnableProductRevamp
} from '../../../refresh/selectors/featureFlagsSelector';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import screen from '../../../refresh/constants/pageType.constant';
import luxeScreens from '../../../refresh/constants/luxeScreenType';
import { deliveryMethod as DELIVERY_METHOD } from '../../../refresh/constants/ordersData.constants';
import { purchaseData, luxePurchaseData } from '../../../refresh/utils/orderConfirmationUtils';
import { Feature, Variant } from '../../../refresh/organism/ABFeature';
import { fetchAssuredGift } from '../../../actions/assuredGiftsActions';
import { getAssuredGiftData, getMembershipBenefitResponse } from '../../../refresh/selectors/cartSelector';
import { jioAdsPurchaseCompleted, jioAdsLocationEvent } from '../../../utils/jioAds';
import { getDiscountValue } from '../../../utils/price';
import { readCookie } from '../../../components/common/Cookie';
import { catalogIdToStoreName } from '../../../utils';
import { getDateRangeForGA } from '../../../edd/utils/getDateRange';
import { subscriptionTypes } from '../../../refresh/pages/SubscriptionLandingPage/constants';
import AjioFirstSummary from './../../../components/desktop/AjioFirstSummery';
import { replaceWithJioCDN } from '../../../utils/imageHandling';
import { formatDate } from '../../../refresh/utils/dateUtils';
import { getAffiliateCookie } from '../../../utils/affiliateUtils';
import GstInfo from '../../../myaccount/components/desktop/GSTSectionODP/GstInfo';
import GstAddressSummary from '../../../myaccount/components/desktop/GSTSectionODP/GstAddressSummary';

const getPriceStripped = (price = '') => price.slice(3).trim();

const itemLabelDetails = (itemDetails = []) => {
  const segmentExperimentData = JSON.parse(localStorage.getItem('segmentExperiment'));
  const products = itemDetails
    .filter(x => !x.isGiftProduct)
    .map(row => {
    const {
      brandName = '',
      brickCategory: Category = '',
      code: skuId = '',
      color = '',
      name: skuName = '',
      quantity = '',
      size = '',
      baseProduct = '',
      catalogName = '',
      priceInfo: {
        couponSaving: { formattedValue: couponSaving = '' } = {},
        discount: { value: discount = '' } = {},
        discountPercentage = '',
        totalSaving: { formattedValue: totalSaving = '' } = {},
        originalPrice: { formattedValue: originalPrice = '', value: wasPrice } = {},
        netPrice: { formattedValue: netPrice = '', value: finalPrice } = {}
      } = {},
      eddLower = '',
      eddUpper = '',
      giftProductsCount = 0
    } = row;
    const localSegmentId = segmentExperimentData?.filter(el => el.code === row.code)[0]?.segmentId;
    const localExperimentId = segmentExperimentData?.filter(el => el.code === row.code)[0]
      ?.experimentId;
    return {
      brandName,
      Category,
      skuId,
      color,
      discount,
      wasPrice,
      finalPrice,
      skuName,
      quantity,
      size,
      couponSaving,
      discountPercentage,
      totalSaving,
      originalPrice,
      netPrice,
      baseProduct,
      catalogName,
      segmentId: localSegmentId,
      experimentId: localExperimentId,
      eddLower,
      eddUpper,
      giftProductsCount
    };
  });
  return products;
};

const getPurchaseProducts = (
  order,
  products = [],
  enableGiftWithProduct,
  entries = [],
  isPriorityDeliveryFlagOn,
  enablePDPhase2,
  enableRushDelivery,
  PLP_BUCKET,
  enableSubscription,
  membershipData,
  membershipSavings
) => {
  let gtmCoupon = '';
  let gtmTotalDiscount = '';
  let gtmMRP = '';
  let gtmNetPrice = '';
  const purchaseProducts = [];
  products.forEach(item => {
    const {
      brandName,
      Category,
      skuId,
      color,
      discount,
      wasPrice,
      finalPrice,
      skuName,
      quantity,
      size,
      couponSaving,
      totalSaving,
      originalPrice,
      netPrice,
      baseProduct = '',
      discountPercentage,
      catalog = '',
      catalogName = '',
      segmentId = '',
      experimentId = '',
      isGiftProduct = false,
      eddLower = '',
      eddUpper = ''
    } = item;
    gtmCoupon = couponSaving ? getPriceStripped(couponSaving) : '';
    gtmTotalDiscount = totalSaving ? getPriceStripped(totalSaving) : '';
    gtmMRP = originalPrice ? getPriceStripped(originalPrice) : '';
    gtmNetPrice = netPrice ? getPriceStripped(netPrice) : '';
    const [productId, variant] =
      baseProduct && baseProduct.includes && baseProduct.includes('_')
        ? baseProduct.split('_')
        : [baseProduct || '', baseProduct || ''];
    const dimension60Data =
      Number(segmentId) || Number(experimentId) ? `${segmentId}|${experimentId}` : '';

    let giftCount = 0;
    if (enableGiftWithProduct) {
      const mainProduct = entries.find(x => x?.product?.code === skuId);
      giftCount = mainProduct?.giftProductsCount || 0;
    }

    const pincode = order?.deliveryInfo?.deliveryAddress?.postalCode || '';
    const entry = (entries || []).find(x => x.product.code === item.skuId);
    let rushDeliveryFee = 0;
    let rushDeliveryEDD = '';
    let rushDeliverySLA = '';
    if (enableRushDelivery) {
      if (entry.deliveryMethod === DELIVERY_METHOD.RUSH) {
        rushDeliverySLA = entries[i]?.deliverySLA;
        rushDeliveryFee = entry?.convenienceFee?.rushDelivery?.netAmount || 0;
        rushDeliveryEDD = getDateRangeForGA({ eddLower, eddUpper }) || '';
      }
    }

    let priorityDeliveryFee = 0;
    let priorityDeliveryEDD = '';
    let priorityDeliverySLA = '';
    if (isPriorityDeliveryFlagOn) {
      const isPriorityDeliveryApplied = enableRushDelivery
        ? entry.deliveryMethod === DELIVERY_METHOD.RUSH
        : entry.isPriorityDeliveryApplied;
      if (isPriorityDeliveryApplied) {
        priorityDeliverySLA = entries[i]?.deliverySLA;
        priorityDeliveryFee = entry?.convenienceFee?.priorityDelivery?.netAmount || 0;
        priorityDeliveryEDD = getDateRangeForGA({ eddLower, eddUpper }) || '';
      }
    }
    const itemToken = getProductAttributionToken(skuId);
    const copilotToken = getCopilotSkuCheck(skuId);
    purchaseProducts.push({
      name: skuName,
      id: baseProduct?.split('_')[0] || skuId,
      skuId,
      brand: brandName,
      category: Category,
      variant: baseProduct?.split('_')[1] || color || variant,
      quantity,
      coupon: gtmCoupon ? parseFloat(gtmCoupon.replace(',', '')) : 0,
      totalDiscount: gtmTotalDiscount ? parseFloat(gtmTotalDiscount.replace(',', '')) : 0,
      MRP: gtmMRP ? parseFloat(gtmMRP.replace(',', '')) : 0,
      price: gtmNetPrice ? parseFloat(gtmNetPrice.replace(',', '')) : 0,
      size,
      discount,
      wasPrice,
      finalPrice,
      dimension12: productId,
      dimension13: skuName,
      dimension14: '',
      dimension15: Category,
      dimension16: Category,
      dimension20: '',
      dimension21: brandName,
      dimension22: gtmNetPrice ? parseFloat(gtmNetPrice.replace(',', '')) : 0,
      dimension23: catalogIdToStoreName(catalog || catalogName),
      dimension24: size,
      dimension60: dimension60Data,
      dimension170: getDiscountValue(discountPercentage),
      ...(pincode && { pincode }),
      ...(giftCount > 0 ? { dimension166: `GetFreebies - ${giftCount}` } : {}),
      ...(isPriorityDeliveryFlagOn && { priorityDeliveryEDD, priorityDeliveryFee }),
      ...(enablePDPhase2 && priorityDeliverySLA && { priority_delivery_sla_tag: PLP_BUCKET[priorityDeliverySLA] }),
      ...(enableRushDelivery && { rushDeliveryEDD, rushDeliveryFee }),
      ...(enableRushDelivery && rushDeliverySLA && { rush_delivery_sla_tag: PLP_BUCKET[rushDeliverySLA] }),
      ...(itemToken && { search_attribution: itemToken }),
      ...(enableSubscription && {
        subscription_delivery_fee_saving: membershipSavings?.deliveryFeeSavings,
        subscription_platform_fee_saving: membershipSavings?.platformFeeSavings,
        subscription_total_savings: membershipSavings?.totalMembershipSavings,
        subscription_membership_discount: membershipSavings?.membershipDiscount
      }),
      ...(copilotToken === 'copilot' && { itm_source_detail: 'ai_assistant_widget' }),
      giftCount
    });
  });
  return purchaseProducts;
};
class OrderConfirmation extends Component {
  constructor(props) {
    super(props);
    this.labels = {
      OrderSummary: 'Order Summary',
      confirmOrderPay: 'Confirm Order & Pay',
      OrderPlaced: 'Order Placed'
    };
    this.state = {
      modalContent: '',
      fixedBtnProps: {
        popupBtnText: 'Proceed To Payment',
        popUpFirstBtnAction: () => {
          this.props.hideModal('order-summary-popup');
        },
        popUpSecondBtnAction: () => {
          window.location = '/checkout';
        },
        firstBtnAction: () => {
          window.location = '/';
        },
        firstBtnText: 'CONTINUE SHOPPING',
        secondBtnAction: () => {
          this.props.promptUserForEmployeeId(() => {
            window.location = '/';
          });
        },
        secondBtnText: 'Sign Out',
        halfnhalfBtns: false,
        secondBtnVariant: 'orange'
      },
      isJioAdsLoaded: true,
      pixels: []
    };
  }

  componentDidMount() {
    if (!isNode()) {
      document.addEventListener('keydown', e => {
        if (e.code === 'Enter') {
          document.activeElement.click();
        }
      });
    }
    const {
      storeName,
      fetchAssuredGift,
      assuredDataFlag,
      isAssured,
      order: {
        code: transactionId = '',
        item = [],
        entries = [],
        totalItems: orderQuantity = '',
        membershipSavings = {},
        orderSummary: {
          orderTotal: { formattedValue: orderTotal = '', value = 0 } = {},
          deliveryCharge: { formattedValue: deliveryCharge = '' } = {},
          bagTotal: { formattedValue: bagTotal = '' } = {},
          couponSaving: { formattedValue: couponSaving = '' } = {},
          bagDiscount: { formattedValue: bagDiscount = '' } = {},
          exclusiveGSTCharge: { formattedValue: exclusiveGSTAmt = '' } = {},
          membershipDetails = {}
        } = {}
      } = {},
      newDesignLuxe,
      order: {
        relianceOneEarnedAmount: { value: rone } = {},
        ajioCashEarnedAmt: { value: cashAmt } = {}
      },
      afsecure,
      enableGiftWithProduct,
      isPriorityDeliveryFlagOn,
      enablePDPhase2,
      enableRushDelivery,
      priorityDeliverySLPTagsConfig: { PLP_BUCKET = {} },
      enableSubscription = false,
      membershipData,
      ajioSuperCashEnable,
      affiliateFeatureConfig,
      enableNonReturnableProductRevamp = false
    } = this.props;
    const pixels = getAffisePixels({
      products: entries,
      items: item,
      orderId: transactionId,
      afsecure,
      channelType: 'Desktop'
    });
    this.setState({ pixels });
    let itemDiscount =[];
    const transactionProducts = item.map(row => {
      const {
        brandName = '',
        brickCategory: Category = '',
        code: skuId = '',
        color = '',
        name: skuName = '',
        quantity = '',
        size = '',
        baseProduct = '',
        priceInfo: {
          couponSaving: { formattedValue: couponSaving = '' } = {},
          discount: { value: discount = '' } = {},
          discountPercentage = '',
          totalSaving: { formattedValue: totalSaving = '' } = {},
          originalPrice: { formattedValue: originalPrice = '' } = {},
          netPrice: { formattedValue: netPrice = '' } = {}
        } = {}
      } = row;
      itemDiscount.push({
        id: skuId,
        discount: discount,
        couponSaving: couponSaving ? getPriceStripped(couponSaving) : ''
      })
      return {
        brandName,
        Category,
        skuId,
        color,
        skuName,
        quantity,
        size,
        couponSaving,
        discountPercentage,
        totalSaving,
        originalPrice,
        netPrice,
        baseProduct
      };
    });
    if (!isNode()) {
      const { location: { pathname = '' } = {}, order } = this.props;
      const pathParts = window?.location?.pathname?.split('/');
      const paymentCode = pathParts[pathParts.length - 1];
      const urlPaymentMode = pathParts?.length > 4 ? paymentCode : '';
      window.transaction = {
        transactionId,
        orderQuantity,
        transactionProducts,
        orderSummary: {
          orderTotal,
          deliveryCharge,
          bagTotal,
          couponSaving,
          bagDiscount
        }
      };
      
      const isEventFired = localStorage.getItem('thankyouOrderId') === transactionId;
      const getValue = (type = '', code = '') =>{
       const index = itemDiscount.findIndex(value => value.id === code);
       if(index != -1){
        return itemDiscount?.[index]?.[type]
       } 
       return 0;
      }
      if(!isEventFired){
        const { entries = [], luxeTotalPrice = {} } = order;
        console.log("orderSummary", order)
        const luxeStoreProduct =  entries?.filter(product => product?.sourceStoreId === 'luxe')?.map((item,index) => ({
          item_id: item?.product?.code,
          item_name: item?.product?.name,
           discount: getValue('discount', item?.product?.code),
          quantity: Number(item?.quantity) || 1,
          index: index,
          item_brand: item?.product?.brandName,
          item_list_name: 'Thankyou',
          item_category: item?.brickCategory,
          item_variant: item?.product?.baseProduct?.split('_')?.[1],
          price: item?.totalPrice?.value,
          product_store_type: 'luxe',
          coupon: getValue('couponSaving', item?.product?.code) ,
        }));
        const contentIds = [];
        const contentData = []
        luxeStoreProduct?.forEach(item => {
            contentIds.push(item?.item_id);
            contentData?.push({
              id: item?.item_id,
              quantity: item?.quantity,
              item_price: item?.price
            })
        })
        console.log("luxeStoreProduct", luxeStoreProduct);

        if (luxeStoreProduct?.length) {
          gtmEventPush({
            event: 'InitiateCheckout',
            action_source: 'website',
            event_source_url: window?.location?.href,
            ecommerce: {
              currency: 'INR',
              value: luxeTotalPrice?.value,
              items: luxeStoreProduct
            },
            custom_data: {
              content_ids: contentIds,
              contents: contentData
            },
            num_items: luxeStoreProduct?.length,
            pricing_cust_seg: readCookie('cohortSegment') || ''
          });
          segmentEventPush({
            event: 'InitiateCheckout',
            action_source: 'website',
            event_source_url: window?.location?.href,
            ecommerce: {
              currency: 'INR',
              value: luxeTotalPrice?.value,
              items: luxeStoreProduct
            },
            custom_data: {
              content_ids: contentIds,
              contents: contentData
            },
            num_items: luxeStoreProduct?.length,
            pricing_cust_seg: readCookie('cohortSegment') || ''
          });
          // window.fbq('track', 'InitiateCheckout', {
          //   Content: luxeStoreProduct,
          //   "Content Type": "product",
          //   "Number of Items": luxeStoreProduct?.length,
          //   "Payment Info": paymentCode,
          //   "Currency": "INR",
          //   "Price": luxeTotalPrice?.value || 0
          // });
        }
      }
      if (!isEventFired) {
        localStorage.setItem('thankyouOrderId', transactionId);
      }
      let message = sessionStorage.getItem('jppmessage');
      try {
        message = JSON.parse(message);
        message && this.props.showErrorMessageInfo(message);
        sessionStorage.removeItem('jppmessage');
        if (
          pathname &&
          Object.prototype.toString.call(pathname) === '[object String]' &&
          pathname.includes('/order/confirm')
        ) {
          const itemList = itemLabelDetails(item);
          const { orderConfirmation: { pageName = '', pageType = '' } = {} } = screen;
          const { order } = this.props;
          console.log(order, 'order11');
          const pincode = order?.deliveryInfo?.deliveryAddress?.postalCode || '';
          gtmPagePush(pageName, pageType, window.__ENV__ || '', {
            rone,
            store: storeName,
            [ajioSuperCashEnable && ['ajio', 'rilfnl', ''].includes(storeName.toLowerCase())
              ? 'order_supercash_earn'
              : 'ajio_wallet']: cashAmt
          },{
              order: order
          });
          let subscriptionDetails = '';
          if (enableSubscription) {
            subscriptionDetails = `${membershipData?.status || 'NA'} | ${membershipData?.detail?.productId || 'NA'} | ${membershipData?.detail?.identifier || 'NA'} | NA`;
          }

          const {
             userDetail: {
               savingBreakup = {},
               orderLeft = 0,
               boughtOn = '',
               validTill = '',
               totalSavings = 0
             } = {}
           } = membershipData;
           const {
             deliveryFeeSaving = 0,
             membershipSaving = 0,
             platformFeeSaving = 0
           } = savingBreakup;
           const membershipSavingsDetails = enableSubscription
             ? {
                 subscription_delivery_fee_saving: membershipSavings?.deliveryFeeSavings || 'NA',
                 subscription_platform_fee_saving: membershipSavings?.platformFeeSavings || 'NA',
                 subscription_total_savings: membershipSavings?.totalMembershipSavings || 'NA',
                 subscription_membership_discount: membershipSavings?.membershipDiscount || 'NA'
               }
             : {};
           const membershipInfo = {
             subscription_status: membershipData?.status || 'NA',
             subscription_version: membershipData?.detail?.identifier || 'NA',
             subscription_id: membershipData?.detail?.productId || 'NA',
             subscripiton_number: 'NA',
             subscription_start_date: boughtOn ? formatDate(boughtOn) : 'NA',
             subscription_end_date: validTill ? formatDate(validTill) : 'NA',
             subscribed_orders_left: orderLeft,
             subscription_first_purcase_date: 'NA',
             total_account_savings: totalSavings,
             platform_account_savings: platformFeeSaving,
             delivery_account_savings: deliveryFeeSaving,
             membership_discount_account_savings: membershipSaving
           };
           const affiliateData = getAffiliateCookie();
          if (newDesignLuxe) {
            const { order } = this.props;
            const {
              code,
              itemRevenue,
              tax,
              shipping,
              appliedCode,
              purchaseProducts,
              enableSubscription,
              membershipDetails
            } = luxePurchaseData(
              order,
              enableGiftWithProduct,
              isPriorityDeliveryFlagOn,
              enablePDPhase2,
              enableRushDelivery,
              PLP_BUCKET,
              enableSubscription,
              membershipDetails
            );
            const {
              luxeStore,
              orderConfirmation: { screenName = '', screenType = '' }
            } = luxeScreens;
            const affiliation = `${luxeStore} Website`;
            if (!isEventFired) {
              luxeGtmPurchaseComplete(
                code,
                affiliation,
                itemRevenue,
                tax,
                shipping,
                appliedCode,
                purchaseProducts,
                '',
                luxeStore,
                subscriptionDetails,
                pincode,
                membershipSavingsDetails,
                enableSubscription ? membershipInfo : {},
                enableNonReturnableProductRevamp,
                order?.emiOfferDetails,
                order?.paymentCode
              );
              localStorage.removeItem('segmentExperiment');
            }
          } else if (!isEventFired) {
            (async function() {
              const purchaseProducts = getPurchaseProducts(
                order,
                itemList,
                enableGiftWithProduct,
                entries,
                isPriorityDeliveryFlagOn,
                enablePDPhase2,
                enableRushDelivery,
                PLP_BUCKET,
                enableSubscription,
                membershipData,
                membershipSavings,
                enableSubscription ? membershipInfo : {}
              );
              const { appliedCode } = purchaseData(order, enableGiftWithProduct);
              gtmPurchaseComplete(
                transactionId,
                getPriceStripped(orderTotal) || 0,
                getPriceStripped(exclusiveGSTAmt) || 0,
                getPriceStripped(deliveryCharge) || 0,
                getPriceStripped(couponSaving) || 0,
                purchaseProducts,
                appliedCode,
                order,
                subscriptionDetails,
                pincode,
                membershipSavingsDetails,
                enableSubscription ? membershipInfo : {},
                urlPaymentMode,
                false,
                '',
                enableNonReturnableProductRevamp
              );
              localStorage.removeItem('segmentExperiment');
            })();
          }
        }
      } catch (error) {
        sessionStorage.removeItem('jppmessage');
      }
      console.log("paymentCode", paymentCode)
      if (window.history && window.history.pushState) {
        window.history.pushState('forward', null, (pathParts?.length > 4 && paymentCode?.length > 0) ? `../#${transactionId}` : `./#${transactionId}`);
        window.addEventListener('popstate', function() {
          window.location.href = '/';
        });
      }
    }
    const { orderConfirmationGifts = 'OFF' } = isAssured;
    const showAssuredGiftsData = orderConfirmationGifts === 'ON';
    if (!newDesignLuxe && assuredDataFlag && showAssuredGiftsData) {
      console.log(
        'TRACK GAME NOT FOUND EXCEPTION - desktop/OrderConfirmation.js componentDidMount'
      );
      fetchAssuredGift(
        { isRequestOrginIsBrowser: true },
        res => {
          const { gifts = [] } = res;
          gifts.map(list => {
            if (list?.hasGift) {
              gtmEventPush({
                event: 'widget interaction',
                event_category: 'widget interaction',
                event_action: 'free gift widget view',
                amount_payable: value
              });
            }
          });
        },
        null,
        value
      );
    }
  }

  componentWillUnmount() {
    if (!isNode()) {
      document.removeEventListener('keydown', () => {});
      window.removeEventListener('popstate', () => {});
    }
  }

  componentDidUpdate() {
    const { order } = this.props;
    console.log('TRACK JIO ADS OBSERVATION POINT 6 ~ order:', order);
    const { JioAds } = window;
    console.log('TRACK JIO ADS OBSERVATION POINT 6 ~ JioAds:', JioAds);
    console.log(
      'TRACK JIO ADS OBSERVATION POINT 6  ~ this.state.isJioAdsLoaded:',
      this.state.isJioAdsLoaded
    );
    if (JioAds && this.state.isJioAdsLoaded) {
      jioAdsPurchaseCompleted(order);
      const locationData = {
        cartItems: order?.item || [],
        locationDetails: {
          pincode: order?.deliveryInfo?.deliveryAddress?.postalCode || '',
          lat: '',
          lon: ''
        }
      };
      console.log(
        '🚀 ~ file: OrderConfirmation.js:392 ~ OrderConfirmation ~ componentDidUpdate ~ locationData:',
        locationData
      );
      jioAdsLocationEvent(locationData);
      this.setState({
        isJioAdsLoaded: false
      });
    }
  }

  getModal(showPopLoader = false) {
    this.props.getQuestions({ statusCode: 'jioprime' }, ({ answer = '' }) => {
      this.setState({ modalContent: answer });
      this.props.showModal('jio-prime-points-description');
    });
  }

  renderEarnAmount = (amount, text) => (
    <div className="ajio-cash-information" aria-label={`${amount} ${text}`}>
      <div>
        <span className="earn-text-bold">
          <strong>
            &#8377;
            {amount}
          </strong>
        </span>
        <span className="earn-text-light"> {text}</span>
      </div>
    </div>
  );

  render() {
    const {
      order = {},
      isServerRendering = false,
      basicInfo = {},
      httpError = {},
      ajioWalletData = {},
      metaData: { sis = false, name: sisName = '' } = {},
      newDesignLuxe,
      isAssured,
      assuredConstants,
      assuredDataFlag,
      giftItem = [],
      membershipData,
      enableSubscription,
      ajioMembershipConfig,
      ajioSuperCashTYPEnable = false,
      ajioCashCurrency: { currencyName: ajioCashCurrencyName = '' } = {},
      storeName,
      enableGST = false,
      enableGstEnhancement = false
    } = this.props;
    const showAjioSuperCashChanges =
      ajioSuperCashTYPEnable && ['ajio', 'rilfnl', ''].includes(storeName.toLowerCase());
    const { orderConfirmationGifts = 'OFF' } = isAssured;
    const showAssuredGiftsData = orderConfirmationGifts === 'ON';
    const { error: { message = '', errorType = '' } = {} } = httpError;
    const { hasGift } = this.props.assuredData;
    const viewRewardsLink = '/my-account/my-rewards';
    const {
      orderSummary = {},
      orderSummary: { orderTotal: { formattedValue: orderTotalAmt = '' } = {}, membershipDetails = {} } = {},
      item = [],
      totalItems = 0,
      orderCreatedDate = new Date(),
      user: { name = '' } = {},
      code = '',
      statusDisplay = '',
      jioPrimeEarnMsg = '',
      ajioCashEarnedAmt = {},
      relianceOneEarnedAmount = {},
      deliveryInfo: { deliveryAddress = {}, deliveryModeValue = '' } = {},
      loyaltyEarnedPoints = 0,
      emiOfferDetails: { cashbackAmount = 0, issuerSlug = '' } = {},
      gstDetails = {}
    } = order;
    const ajioWalletEarnAmount = _get(ajioWalletData, 'ajioWalletEarnAmount', '0');
    let ajioCashValue = _get(ajioCashEarnedAmt, 'value', '0');
    const r1EarnPoints = _get(relianceOneEarnedAmount, 'value', 0);
    if (!ajioCashValue) {
      ajioCashValue = ajioWalletEarnAmount;
    }

    const { modalContent = '', pixels } = this.state;
    const pickupOrder = isOrderPickup({ deliveryModeValue });

    const ajioSupercashLabel = showAjioSuperCashChanges ? ajioCashCurrencyName : 'SuperCash';
    const emiDiscountlabel = `Cashback on ${issuerSlug}`
    return (
      <Layout
        header
        footerSeo
        isServerRendering={isServerRendering}
        basicInfo={basicInfo}
        isFooter
        fixedBtnProps={this.state.fixedBtnProps}
      >
        {Object.keys(httpError).length != 0 && errorType == 'info' ? (
          <div className="err-msg-blk absolute">
            <ErrorMessage message={message} device="desktop" showCloseButton={false} />
          </div>
        ) : (
          ''
        )}
        <div
          className={
            newDesignLuxe
              ? 'checkout-order-summary ch-or-summary-mr-luxe '
              : 'checkout-order-summary'
          }
        >
          <OrderDetailsSummary
            name={name}
            code={code}
            statusDisplay={statusDisplay}
            isServerRendering={isServerRendering}
            newDesignLuxe={newDesignLuxe}
          />
        </div>
        <div className="orderconfirm-container" id="dOrderConfirmContainer">
         
          <div className="checkout-summary">
          <h1 aria-label={this.labels.OrderSummary}>{this.labels.OrderSummary}</h1>
            {(pixels || []).map((pixel, index) => (
              <img
                src={replaceWithJioCDN(pixel)}
                alt=""
                key={index}
                style={{
                  position: 'absolute',
                  top: '-9999px',
                  width: '1px',
                  height: '1px',
                  border: 0
                }}
              />
            ))}
            {this._renderCartItem(item)}
          
          </div>
          <div className="right-div">
            <div className="panel-msg-section">
              <div
                className="paneltop"
                aria-label="What Happens Next:"
                role="heading"
                aria-level={2}
              >
                <strong>What Happens Next:</strong>
              </div>
              <ul className="panellist">
                <li aria-label='Sit back and relax!'>Sit back and relax!</li>
                <li aria-label='We will send your order confirmation details to your registered email address and mobile number.'>
                  We will send your order confirmation details to your registered email address and
                  mobile number.
                </li>
                <li aria-label='We will inform you as soon as your package is dispatched.'>We will inform you as soon as your package is dispatched.</li>
                {pickupOrder ? (
                  <li aria-label='The order will be delivered to the chosen store. Pick it up from the store at your convenience.'>
                    The order will be delivered to the chosen store. Pick it up from the store at
                    your convenience.
                  </li>
                ) : (
                  <li aria-label='Once dispatched, you can track your order details through your'>
                    Once dispatched, you can track your order details through your{' '}
                    <a href="/my-account/orders" className="bolder">
                      <strong
                        aria-label='Account page' onClick={() => {
                          if (newDesignLuxe) {
                            const {
                              luxeStore,
                              orderConfirmation: { screenName = '', screenType = '' }
                            } = luxeScreens;
                            gtmEventPush({
                              event: 'order_confirm_interaction',
                              event_category: 'order confirmation interactions',
                              event_action: 'user interactions',
                              event_label: 'account page clicked',
                              page_type: screenType,
                              store_type: luxeStore
                            });
                          }
                        }}
                      >
                        Account page
                      </strong>
                    </a>{' '}
                    or directly through a link on the footer.
                  </li>
                )}
              </ul>
            </div>

        
            {jioPrimeEarnMsg.length > 0 ? (
              <div className="panel-msg-section jioprime-earn-information">
                <p className="paneltop">
                  Jio Prime Points <span className="new">NEW</span>
                </p>
                <p className="jio-prime-information">{jioPrimeEarnMsg}</p>
              </div>
            ) : (
              ''
            )}
            {ajioCashValue || loyaltyEarnedPoints || r1EarnPoints ? (
              <div className="panel-msg-section ajiocash-earn-information">
                <div className="earn-info-msg">
                  <p className="ajiocash-paneltop" aria-label="You have Earned" role='heading' aria-level={2}>
                    <strong>You have Earned</strong>
                  </p>
                  {cashbackAmount ? this.renderEarnAmount(cashbackAmount, emiDiscountlabel) : ''}
                  {ajioCashValue ? this.renderEarnAmount(ajioCashValue, ajioSupercashLabel) : ''}
                  {loyaltyEarnedPoints
                    ? this.renderEarnAmount(loyaltyEarnedPoints, 'Loylty Rewardz Points')
                    : ''}
                  {r1EarnPoints ? this.renderEarnAmount(r1EarnPoints, 'RelianceOne Points') : ''}
                  {ajioCashValue ? (
                    <a
                      href="/my-account/ajio-wallet-bonus"
                      aria-label="Go to Ajio Wallet"
                      onClick={() => {
                        if (newDesignLuxe) {
                          const {
                            luxeStore,
                            orderConfirmation: { screenName = '', screenType = '' }
                          } = luxeScreens;
                          gtmEventPush({
                            event: 'order_confirm_interaction',
                            event_category: 'order confirmation interactions',
                            event_action: 'user interactions',
                            event_label: 'ajio wallet clicked',
                            page_type: screenType,
                            store_type: luxeStore
                          });
                        }
                      }}
                    >
                      <p className="panel-action">
                        <strong>Go to AJIO Wallet</strong>
                      </p>
                    </a>
                  ) : (
                    ''
                  )}
                </div>
                <div className="earn-info-image">
                  <img
                    src={`${properties.getProperty('imageBaseUrl')}/static/img/ajio-cash-earn.svg`}
                    alt=""
                  />
                </div>
              </div>
            ) : (
              ''
            )}
            <Feature featureName="assured-gifts">
              <Variant id="0">{null}</Variant>
              <Variant id="1">
                {!newDesignLuxe && assuredDataFlag && hasGift && showAssuredGiftsData && (
                  <div className="assured-gifts-container">
                    <div className="assured-gifts-header">
                      <img
                        src={`${properties.getProperty(
                          'imageBaseUrl'
                        )}/static/img/assured-gift-box.svg`}
                        alt="Gift icon"
                        className="assured-gift-box"
                      />
                      <p>{assuredConstants?.giftBoxText}</p>
                    </div>
                    <div className="assured-gifts-bottom">
                      <p>{assuredConstants?.detailsSent}</p>
                      <div
                        role="presentation"
                        onClick={() => {
                          gtmEventPush({
                            event: 'widget interaction',
                            event_category: 'widget interaction',
                            event_action: 'free gift widget click',
                            amount_payable: orderSummary?.orderTotal?.value
                          });
                          window.location.href = viewRewardsLink;
                        }}
                      >
                        {assuredConstants?.viewRewards}
                      </div>
                    </div>
                  </div>
                )}
              </Variant>
            </Feature>
            {enableSubscription &&
            ajioMembershipConfig?.isEnableForThankyou &&
            membershipData?.status === subscriptionTypes.SUBSCRIBED ? (
              <AjioFirstSummary membershipSavingSummery={order?.membershipSavings} />
            ) : null}
            {(enableGST || enableGstEnhancement) && gstDetails?.gstNumber ? <GstInfo isThankYouPage /> : null}
              <OrderSummary
                cart={order}
                showCredits
                showAjioCash={false}
                source="desktop"
                orderConfirmPage
                isThankYouPage={false}
                giftItem={giftItem}
              />
            
            {enableGstEnhancement && gstDetails?.gstNumber ? (
              <GstAddressSummary />
            ) : (
              <div className="address-section thank-you-page">
                <AddressBox address={deliveryAddress} isPageType="orderDetails" />
                {pickupOrder && (
                  <img
                    alt=""
                    src={`${properties.getProperty(
                      'imageBaseUrl'
                    )}/static/img/pickFromStoreTag.svg`}
                    className="pickTag"
                  />
                )}
              </div>
            )}
          </div>
           <FeedbackRating rating="" source="desktop" />
          <br />
          <br />
          <Modal name="jio-prime-points-description" className="jio-prime-modal" id="jioPrimePopup">
            <div className="question-modal" dangerouslySetInnerHTML={{ __html: modalContent }} />
          </Modal>
        </div>
      </Layout>
    );
  }

  _renderCartItem(cartItem) {
    const { newDesignLuxe, order = {} } = this.props;
    const { entries = [] } = order;
    return cartItem.map((item = {}, index) => {
      const confirmPageUrl = _get(window, 'location.href', '');
      const entry = entries.find(e => e.code === item.code) || entries[index] || {};
      const enrichedItem = {
        ...item,
        returnWindow: entry.returnWindow,
        isReturnable: entry.isReturnable || entry.returnWindow > 0,
        isExchangeable: entry.isExchangeable || entry.returnWindow > 0
      };
      return Object.keys(item).length > 0 ? (
        <CartProductCard
          confirmPageUrl={confirmPageUrl}
          idx={index}
          product={enrichedItem}
          key={index}
          orderPageTitle="orderconfirm"
          newDesignLuxe={newDesignLuxe}
        />
      ) : null;
    });
  }
}

const mapStateToProps = state => {
  const { order = {}, metaData = {}, httpError = {}, ajioWalletData = {}, flags } = state;
  const { item } = order;
  const giftItemArray = item?.filter(cartItem => cartItem?.isGiftProduct) || [];

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const isAssured = getAssuredGiftsFlag(state);
  const assuredDataFlag = getAssuredGifts(flags);
  const assuredData = getAssuredGiftData(state);
  const assuredConstants = getAssuredFlags(state);
  const afsecure = getAffiseAfSecure(flags);
  const enableGiftWithProduct = getGiftWithProductEnable(flags);
  const isPriorityDeliveryFlagOn = getPriorityDeliveryPreOrderFlag(flags);
  const enablePDPhase2 = getPriorityDeliveryPhase2Flag(flags);
  const enableRushDelivery = getRushDeliveryFlag(state);
  const priorityDeliverySLPTagsConfig = getPriorityDeliverySLPTagsConfig(state);
  const enableSubscription = getEnableAjioMemberShipProgram(flags, state) || false;
  const ajioMembershipConfig = getAjioMemberShipConfig(flags, state) || {};

  const ajioSuperCashTYPEnable = getAjioSuperCashTYPEnable(flags);
  const ajioCashCurrency = getAjioSuperCashCurrencyConfig(flags);
  const ajioSuperCashEnable = getAjioSuperCashEnable(flags);
  const enableGST = getGSTFlag(state);
  const enableGstEnhancement = getGstEnhancementFlag(state, 'thankyou');
  return {
    order,
    metaData,
    httpError,
    ajioWalletData,
    newDesignLuxe,
    isAssured,
    assuredData,
    assuredConstants,
    assuredDataFlag,
    storeName,
    afsecure,
    enableGiftWithProduct,
    giftItem: giftItemArray,
    isPriorityDeliveryFlagOn,
    enablePDPhase2,
    enableRushDelivery,
    priorityDeliverySLPTagsConfig,
    ajioSuperCashTYPEnable,
    ajioCashCurrency,
    ajioSuperCashEnable,
    enableGST,
    enableGstEnhancement,
    membershipData: state?.membership?.membershipData || {},
    enableSubscription,
    ajioMembershipConfig,
    affiliateFeatureConfig: getAffiliateFeatureConfig(state),
    enableNonReturnableProductRevamp: getEnableNonReturnableProductRevamp(state)
  };
};

function mapDispatchToProps(dispatch) {
  return {
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    getQuestions: (reqObj, callback) => {
      dispatch(getQuestions(reqObj, callback));
    },
    promptUserForEmployeeId: callback => {
      dispatch(promptUserForEmployeeId(callback));
    },
    showErrorMessageInfo: messageObj => {
      dispatch(showErrorMessageInfo(messageObj));
    },
    fetchAssuredGift: (reqObj, callback, isRecursivelyCalling, orderValue) => {
      dispatch(fetchAssuredGift(reqObj, callback, isRecursivelyCalling, orderValue));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderConfirmation);
